// src/data/landmarks/index.js

export const LANDMARK_FILES = [
  'hello',
  'name',
  'my',
  'goodbye',
  'sorry',
  'red',
  'brother',
  'sister',
  'mother',
  'happy',
  'sad',
  'like',
  'talk',
  'go',
  'why',
  'tell',
  'when',
  'today',
  'tomorrow',
  'yesterday',
  'water',
  'eat',
  'drink',
  'car',
  'dog',
  'cat',
  'spring',
  'winter',
  'sun',
];